import React from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default () => {
  return (
    <APIDocsBlock>
      <div>
        <div className="heading">Update post</div>
        <div className="text">Updates an existing post.</div>
        <APIDocsTable
          title="Arguments"
          rows={[
            {
              description: 'Your secret API key.',
              heading: 'apiKey',
              subheading: 'string',
            },
            {
              description: 'The unique identifier of the post.',
              heading: 'postID',
              subheading: 'string',
            },
            {
              description:
                'Any custom fields associated with the post. Each field name (key) must be between 0 and 30 characters long. If field values are strings, they must be less than 200 characters long.',
              heading: 'customFields',
              subheading: 'object (optional)',
            },
            {
              description: 'The post details.',
              heading: 'details',
              subheading: 'string (optional)',
            },
            {
              description:
                "The estimated date of the post's completion. In the format of MM/YYYY, eg, 06/2022.",
              heading: 'eta',
              subheading: 'string (optional)',
            },
            {
              description: 'If the ETA should be made visible to all users.',
              heading: 'etaPublic',
              subheading: 'boolean (optional)',
            },
            {
              description: 'The post title.',
              heading: 'title',
              subheading: 'string (optional)',
            },
            {
              description: "An array of the URLs of post's images.",
              heading: 'imageURLs',
              subheading: 'array (optional)',
            },
          ]}
        />
        <div className="subheading">Returns</div>
        <div className="text">Returns "success" if the post was updated successfully.</div>
      </div>
      <div>
        <div className="text">Endpoint</div>
        <Highlight lang="http">https://canny.io/api/v1/posts/update</Highlight>
        <APIDocsMethod />
        <APIDocsCurl
          path="https://canny.io/api/v1/posts/update"
          body={`-d '{
    "apiKey": "YOUR_API_KEY",
    "postID": "553c3ef8b8cdcd1501ba1238",
    "customFields": {
      "number": 12,
      "string": "value"
    },
    "details": "Updated post details",
    "title": "Updated post title",
    "eta": "01/2025",
    "imageURLs": ["https://picsum.photos/200"],
    "etaPublic": true}' \\
    -H "Content-Type: application/json"`}
        />
        <div className="text">Example Response</div>
        <Highlight lang="json">success</Highlight>
      </div>
    </APIDocsBlock>
  );
};
